"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateQueryRunRpcResponseImplementation = exports.CreateQueryRunRpcRequestImplementation = void 0;
const core_1 = require("./core");
class CreateQueryRunRpcRequestImplementation extends core_1.BaseRpcRequest {
    constructor() {
        super(...arguments);
        this.method = "createQueryRun";
    }
}
exports.CreateQueryRunRpcRequestImplementation = CreateQueryRunRpcRequestImplementation;
class CreateQueryRunRpcResponseImplementation extends core_1.BaseRpcResponse {
}
exports.CreateQueryRunRpcResponseImplementation = CreateQueryRunRpcResponseImplementation;
//# sourceMappingURL=create-query-run.type.js.map